import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core"
import { UserService } from "../../services/user.service"
import { Params, QueryParamsHandling } from "@angular/router"

@Component({
    selector: "app-link",
    templateUrl: "./link.component.html",
    styleUrls: ["link.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class LinkComponent implements OnInit {
    @Input() href = null
    @Input() appRouterLink: any[] | string | null | undefined = null
    @Input() queryParams: Params
    @Input() routerLinkActive: string[] | string = ""
    @Input() queryParamsHandling: QueryParamsHandling = null
    @Input() title: string = ""
    @Input() target: string = ""
    @Input() badgeCount: number = 0

    constructor(private userService: UserService) {}

    public ngOnInit() {
        const params = this.userService.getStudentQueryParams()
        if (Object.keys(params).length !== 0) {
            if (this.appRouterLink && !this.hasStudent()) {
                this.queryParams = {
                    ...this.queryParams,
                    ...params,
                }
            } else if (this.href) {
                this.href += this.href.includes("?") ? "&student=true" : "?student=true"
            }
        }
    }

    private hasStudent() {
        if (Array.isArray(this.appRouterLink)) {
            if (
                (this.appRouterLink[0] === "" || this.appRouterLink[0] === "/") &&
                this.appRouterLink[1]
            ) {
                return this.hasStrStudent(this.appRouterLink[1])
            } else {
                return this.hasStrStudent(this.appRouterLink[0])
            }
        } else if (typeof this.appRouterLink === "string") {
            return this.hasStrStudent(this.appRouterLink)
        }

        return false
    }

    private hasStrStudent(str: string) {
        if (str.includes("/")) {
            const fragments = str.split("/")
            return fragments[1] === "student"
        }

        return str === "student"
    }
}
